// TODO: использовать не только для escape, а для всех клавиш
// TODO: добавить разрешенные элементы с фокусом (чтобы на них работало условие проверки keyup)
// TODO: использовать глобальный обработчик на основе входящих настроек (т.е. на все другие composable используем один обработчик на основе настроек)

let isDocumentFocused: boolean = document.hasFocus(); // в целом не нужная вещь, но при закрытии filepicker срабатывает keyup
let deferredFocusedTimeout: ReturnType<typeof setTimeout> | null = null;

function cleanupDeferredFocusedTimeout() {
  if (deferredFocusedTimeout) {
    clearTimeout(deferredFocusedTimeout);
    deferredFocusedTimeout = null;
  }
}

function updateFocusWindowState(event: FocusEvent) {
  const value = event.type === 'focus';
  if (isDocumentFocused === value)
    return;

  cleanupDeferredFocusedTimeout();

  if (value) {
    deferredFocusedTimeout = setTimeout(() => {
      isDocumentFocused = true;
    }, 100);
  }
  else {
    isDocumentFocused = false;
  }
}

document.addEventListener('focus', updateFocusWindowState, { passive: true });
document.addEventListener('blur', updateFocusWindowState, { passive: true });

export function useCloseEscape(handle: (event: KeyboardEvent) => void, options?: { passive: boolean, capture: boolean, canHandleEvent?: (event: KeyboardEvent) => boolean }) {
  const { passive, capture, canHandleEvent } = options ?? { passive: true };

  let listen: boolean = true;
  let keyEscapeDownTimestamp: number = 0;

  const isEscapeKey = (event: KeyboardEvent) => {
    if (event.key !== 'Escape')
      return false;
    if (event.shiftKey || event.metaKey || event.ctrlKey)
      return false;

    return true;
  };

  const onKeyUp = (eventKeyUp: KeyboardEvent) => {
    if (!listen)
      return;

    if (isEscapeKey(eventKeyUp)) {
      // примерно среднее значение нажимания и отпускания, когда считаем что является залипшим нажатием
      if (eventKeyUp.timeStamp - keyEscapeDownTimestamp > 500)
        return;

      if (isDocumentFocused && (document.activeElement == null || document.activeElement === document.documentElement || document.activeElement === document.body || canHandleEvent?.(eventKeyUp))) {
        handle(eventKeyUp);
      }
    }
  };

  const onKeyDown = (eventKeyDown: KeyboardEvent) => {
    if (!listen)
      return;

    if ((!eventKeyDown.repeat || !keyEscapeDownTimestamp) && isEscapeKey(eventKeyDown)) {
      keyEscapeDownTimestamp = eventKeyDown.timeStamp;
    }
  };

  const stopListen = () => {
    listen = false;
  };

  const startListen = () => {
    listen = true;
  };

  document.addEventListener('keyup', onKeyUp, { passive, capture });
  document.addEventListener('keydown', onKeyDown, { passive, capture });

  onBeforeUnmount(() => {
    document.removeEventListener('keyup', onKeyUp, { capture });
    document.removeEventListener('keydown', onKeyDown, { capture });
  });

  return {
    stopListen,
    startListen,
  };
}
